import { render, staticRenderFns } from "./TopicsCreateModal.vue?vue&type=template&id=5f013f0a&"
import script from "./TopicsCreateModal.vue?vue&type=script&lang=js&"
export * from "./TopicsCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports